import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "react-bootstrap-v5";
import ReactPaginate from "react-paginate";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import Select from "react-select";
import Loader from "../../Components/Loader";
import { reportService } from "../../Services/reportService";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
let param = {};

const typeoption = [
  { value: "", label: "All" },
  { value: "individual", label: "Individual" },
  { value: "commercial", label: "Commercial" },
  { value: "trade_partner", label: "Trade Partner" },
];

export const CustomerReport = () => {
  const [reportlist, setReportlist] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [seltype, setSeltype] = useState("");
  const [searchField, setSearchField] = useState();

  const componentRef = useRef();

  const getData = (page , searchField, seltype, startDate, endDate) => {
    setLoader(true);
    setSearchField(searchField)
    setSeltype(seltype)
    let param = {};
    param = { ...param, page: page, limit: pagination.limit };

    if (startDate && endDate) {
      param["start_date"] = getTimeStamp(startDate);
      param["end_date"] = getTimeStamp(endDate);
    }
    if (seltype !== "" && seltype !== undefined) {
      param["type"] = seltype;
    }
    if (searchField) {
      param["search"] = searchField;
    }

    reportService
      .getCustomerReport(param)
      .then((res) => {
        setReportlist(res.data);
        setLoader(false);
        setPagination({ ...pagination, ...res.pagination });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTimeStamp = (date) => {
    let SingleTimestamp = new Date(date);
    return SingleTimestamp.getTime();
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
    getData(e.selected + 1, searchField, seltype, startDate, endDate);
  };

  const exportToExcel = () => {
    const params = startDate
      ? { start_date: startDate, end_date: endDate }
      : null;
    if (seltype !== "") {
      param["type"] = seltype;
    }
    if (searchField) {
      param["search"] = searchField;
    }
    reportService.customerReportexcel(params).then((result) => {
      if (result.status === true) {
        window.location.href = `${REACT_APP_API_BASEURL}/${result.data}`;
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const handleDateFilter = (e) => {
    const { name, value } = e.target;
    if(name === "start_date"){
        setStartDate(value)
        if(value && endDate) getData(currentPage, searchField, seltype, e.target.value, endDate)
      }else{
        if(value && startDate) getData(currentPage, searchField, seltype, startDate, e.target.value)
        setEndDate(value)
      }
  }

  useEffect(() => {
      getData(currentPage);
  },[]);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-2">
                <label>Search</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search.."
                  onChange={(e) => (!e.target.value || e.target.value.length>2) && getData(currentPage, e.target.value, seltype, startDate, endDate)}
                  // value={searchField}
                />
              </div>
              <div className="col-sm-2">
                <label>Type</label>
                <Select
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      height: "34px",
                      minHeight: "34px",
                      display: "flex",
                      alignItems: "center",
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "34px",
                      display: "flex",
                      alignItems: "center",
                      padding: "0px 8px",
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: "34px",
                      display: "flex",
                      alignItems: "center",
                    }),
                  }}
                  onChange={(e) => getData(currentPage, searchField, e.value, startDate, endDate)}
                  placeholder="Select Type"
                  options={typeoption}
                />
              </div>
              <div className="col-md-2">
                <label>Start Date</label>
                <input
                  type="date"
                  name="start_date"
                  className="form-control"
                  onChange={handleDateFilter}
                  value={startDate}
                />
              </div>
              <div className="col-md-2">
                <label>End Date</label>
                <input
                  type="date"
                  name="end_date"
                  className="form-control"
                  onChange={handleDateFilter}
                  value={endDate}
                />
              </div>
              <div className="col-md-4 d-flex justify-content-end mt-3">
                <Button
                style={{height: "40px"}}
                  className="me-2 ps-4 pe-4"
                  variant="success"
                  onClick={exportToExcel}
                >
                  {" "}
                  Excel{" "}
                </Button>
              </div>
            </div>
            <div className="table-responsive" ref={componentRef}>
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Job Number</th>
                    <th>Customer Name</th>
                    <th>Type</th>
                    <th>Sub Category</th>
                    <th>Job Date</th>
                    <th>Destination</th>
                  </tr>
                </thead>
                <tbody>
                  {reportlist &&
                    reportlist.length > 0 &&
                    reportlist.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{item?.job_token}</td>
                        <td 
                          className="str-hover-show"
                          showfullonhover={item?.user_detail.user_full_name}
                        >
                          {item?.user_detail.user_full_name
                            ? item?.user_detail.user_full_name.length > 40
                              ? `${item?.user_detail.user_full_name.slice(
                                  0,
                                  40
                                )}...`
                              : item?.user_detail.user_full_name
                            : "NA"}
                        </td>
                        <td>{item?.user_detail.type}</td>
                        <td>{item?.user_detail.sub_category}</td>
                        <td>
                          {item?.created_at
                            ? moment(item?.created_at).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>
                          <div >
                            {/* {item?.shipment_details.destination + " , " + item?.shipment_details.destination_country} */}
                            {item?.shipment_details?.destination
                              ? item.shipment_details.destination +
                                (item.shipment_details.destination_country
                                  ? " , " +
                                    item.shipment_details.destination_country
                                  : "")
                              : ""}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {reportlist?.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {reportlist &&
                reportlist.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
            </div>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerReport;
